import UploadFilePopover from './index.vue'

let instance

// 先做单实例
const install = Vue => {
	const PopoverConstructor = Vue.extend(UploadFilePopover)

	const Popover = () => {
		console.log('create instance')
		instance = new PopoverConstructor()
		instance.$mount()
		document.body.appendChild(instance.$el)
		return instance
	}

	Popover.show = (opts) => {
		if (!instance) Popover()
		if (opts.api) instance.addFile(opts)
	}
	Popover.hide = () => {
		if (instance) instance.hide()
	}
	Popover.clear = () => {
		if (instance) instance.clear()
	}
	Popover.destory = () => {}

	Vue.prototype.$uploadFilePopover = Popover
}

export default { install }
